import { inject, Injectable } from "@angular/core";
import { MCApprovalTypeId, MCDialog, MCDialogButton, MCDialogFooter, MCDialogHeader } from "@maslul/common-services";
import { RequestApprovalTypeDetailsStore } from "../store/approval-type-details-store";
import { TABS } from "../../enum/request/TABS";
import { GeneralDetailsStore } from "../store/general-details";
import { ProductsStoreService } from "../store/products";
import { RequestDetailsStore } from "../store/request-details";
import { AttachmentsStore } from "../store/attachments";
import { DeclarationsStore } from "../store/declarations";


@Injectable({
    providedIn: 'root',
})
export class ApprovalTypesService {

    private requestApprovalTypeDetailsStore = inject(RequestApprovalTypeDetailsStore);
    private generalDetailsStore = inject(GeneralDetailsStore);
    private productsStoreService = inject(ProductsStoreService);
    private requestDetailsStore = inject(RequestDetailsStore);
    private attachmentsStore = inject(AttachmentsStore);
    private declarationsStore = inject(DeclarationsStore);

    public readonly defaultMaxCountRows = 5;
    public readonly maxCountRowsToApprovalTypeId: { [approvalTypeId: number]: number } = {};

    constructor() {
        this.initMaxCountRowList();
    }

    getMaxCountRows(approvalTypeId: number): number {
        return this.maxCountRowsToApprovalTypeId[approvalTypeId] ?? this.defaultMaxCountRows;
    }

    initMaxCountRowList() {
        // Only approval types with a stricter limit than the default (5) are listed here
        this.maxCountRowsToApprovalTypeId[MCApprovalTypeId.RATA] = 1;              // 200
        this.maxCountRowsToApprovalTypeId[MCApprovalTypeId.STANDARDS_EXEMPT_PI] = 1; // 260
        this.maxCountRowsToApprovalTypeId[MCApprovalTypeId.Tourist] = 1;           // 261
        this.maxCountRowsToApprovalTypeId[MCApprovalTypeId.Immigrant] = 1;         // 262
        this.maxCountRowsToApprovalTypeId[MCApprovalTypeId.TZAMA_2] = 1;           // 145
        this.maxCountRowsToApprovalTypeId[MCApprovalTypeId.TZAMA_19] = 1;          // 211
        this.maxCountRowsToApprovalTypeId[MCApprovalTypeId.Diplomat] = 1;          // 355
    }

    isExistTabToApproval(tab: TABS | number) {
        const isExist = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTabs.includes(tab);
        return isExist;
    }

    clearStoreOnApprovalChange() {
        this.generalDetailsStore.initStore();
        this.requestApprovalTypeDetailsStore.initStore();
        this.productsStoreService.initStore();
        this.requestDetailsStore.initStore();
        this.attachmentsStore.initStore();
        this.declarationsStore.initStore();
        window.sessionStorage.clear();
    }

    showDialogOnApprovalChange(dialogProperties: MCDialog, dialogText: any) {
        dialogProperties.visible = true;


        dialogProperties.header = new MCDialogHeader();
        dialogProperties.header.closeButton = new MCDialogButton();
        dialogProperties.header.closeButton.label = "X";
        dialogProperties.header.closeButton.event = () => { dialogProperties.visible = false };

        dialogProperties.footer = new MCDialogFooter();
        dialogProperties.footer.button = new MCDialogButton();
        dialogProperties.footer.button.label = dialogText.okButton;
        dialogProperties.footer.button.event = () => {
            this.clearStoreOnApprovalChange();
            dialogProperties.visible = false
        };


        dialogProperties.footer.secondButton = new MCDialogButton();
        dialogProperties.footer.secondButton.label = dialogText.cancelButton;
        dialogProperties.footer.secondButton.class = "mi-white-button";
        dialogProperties.footer.secondButton.event = () => { dialogProperties.visible = false };
    }

    isChangeAprovalType(approvalTypeId: string): boolean {
        const approvalTypeIdFromStore = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId;
        return approvalTypeIdFromStore !== '' && approvalTypeIdFromStore !== approvalTypeId.toString();
    }
}